export function normalizeString(str: undefined): undefined;
export function normalizeString(str: string): string;
export function normalizeString(str: string | undefined): string | undefined;
export function normalizeString(str: string | undefined): string | undefined {
  return str?.trim()?.toLocaleUpperCase();
}
